/**
 * Single layout block: EmployeeWise toolbar + TanStack individual-details grid.
 * Reused by DRI Insights (CertificationsInsightsSection) and My Team employee-wise DRI.
 */
import React from 'react';
import { Box } from '@mui/material';
import { DriEmployeeWiseSectionToolbar, type DriEmployeeWiseSectionToolbarProps } from './DriEmployeeWiseSectionToolbar';
import IndividualDetailsTable, {
  type IndividualDetailsFilterHandlers,
  type IndividualDetailsFilterState,
} from '../tables/driInsights/IndividualDetailsTable';
import type { DRIValueType, IndividualDetailsRow } from '../../types/driInsights';

export type EmployeeWiseDriInsightsPanelProps = DriEmployeeWiseSectionToolbarProps & {
  rows: IndividualDetailsRow[];
  gridColumns: string[];
  gridCellValueType: DRIValueType;
  onGridCellValueTypeChange: (value: DRIValueType) => void;
  onFilterClick: (
    event: React.MouseEvent<HTMLElement>,
    columnId: string,
    useCheckbox?: boolean,
    isNumeric?: boolean,
    isDateRange?: boolean
  ) => void;
  filterState: IndividualDetailsFilterState;
  filterHandlers: IndividualDetailsFilterHandlers;
  /** Flat table chrome when nested (matches `IndividualDetailsTable` flushChrome). */
  flushTableChrome?: boolean;
  paginationResetDeps?: unknown;
};

const EmployeeWiseDriInsightsPanel: React.FC<EmployeeWiseDriInsightsPanelProps> = ({
  rows,
  gridColumns,
  gridCellValueType,
  onGridCellValueTypeChange,
  onFilterClick,
  filterState,
  filterHandlers,
  flushTableChrome = false,
  paginationResetDeps,
  ...toolbarProps
}) => {
  return (
    <Box sx={{ mb: 2, mt: 1 }}>
      <DriEmployeeWiseSectionToolbar {...toolbarProps} />
      <IndividualDetailsTable
        rows={rows}
        gridColumns={gridColumns}
        gridCellValueType={gridCellValueType}
        onGridCellValueTypeChange={onGridCellValueTypeChange}
        onFilterClick={onFilterClick}
        filterState={filterState}
        filterHandlers={filterHandlers}
        flushChrome={flushTableChrome}
        paginationResetDeps={paginationResetDeps}
      />
    </Box>
  );
};

export default EmployeeWiseDriInsightsPanel;
